<div class="row form">
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <app-hotel-menutab [isEdit]="isEdit" [nameMenu]="nameMenu" [branchofficeSlug]="branchofficeSlug"
      [checkId]="checkId"></app-hotel-menutab>
  </div>
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <div class="page-title-box form__head">
      <div class="row align-items-center">
        <div class="col-sm-6 col-6">
          <a class="page-title form__head__title" (click)="cancel()">
            <i class="fas fa-arrow-left m-r-5"></i>Galería fotos / {{item.value.tradename}}<span
              class="text-success"></span>
          </a>
        </div>
        <div class="col-sm-6 col-6 form__head__boxBtn">
          <a class="btn btn-light d-inline" (click)="refresh()"><i class="fas fa-undo"></i> Recargar</a>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-12">
    <div class="card m-b-30">
      <div class="card-body">
        <form validate [formGroup]="item" (ngSubmit)="onSubmit()">
          <div class="row">
            <div class="col-lg-12">
              <div class="row">
                <div class="col-12">
                  <span class="badge badge-secondary bold">
                    El peso de la imagen de protada debe ser menor a 0.5 MB
                  </span>
                </div>
                <div class="col-lg-3">
                  <!-- <p class="text-center p-t-15">
                    <ng-container *ngIf="item.value.url_image != null">
                      <img width="200" height="165" src="tenants/{{item.value.url_image}}" alt="Preview">
                    </ng-container>
                    <ng-container *ngIf="item.value.url_image == null">
                      <ng-container *ngIf="imageUrl == null">
                        <img id="output" width="200" src="/images/default.png" />
                      </ng-container>
                      <ng-container *ngIf="imageUrl != null">
                        <img width="200" height="165" [src]="imageUrl" alt="Preview">
                      </ng-container>
                    </ng-container>
                  </p>

                  <p class="text-center">
                    <label for="file" style="cursor: pointer" class="m-b-0"><i class="fas fa-upload"></i>
                      Seleccionar Imagen Portada
                      <input id="file" type="file" (change)="onFileSelected($event)" accept=".png, .jpg, .jpeg"
                        style="visibility: hidden;">
                    </label>
                  </p> -->
                  <p class="text-center p-t-15">
                    <ng-container *ngIf="item.value.url_image != null">
                      <img width="230" height="185" src="tenants/{{item.value.url_image}}" alt="Preview">
                    </ng-container>
                    <ng-container *ngIf="item.value.url_image == null">
                      <ng-container *ngIf="imageUrl == null">
                        <img id="output" width="200" src="/images/default.png" />
                      </ng-container>
                      <ng-container *ngIf="imageUrl != null">
                        <img width="230" height="185" [src]="imageUrl" alt="Preview">
                      </ng-container>
                    </ng-container>
                  </p>
                  <p class="text-center">
                    <label for="file" style="cursor: pointer" class="m-b-0"><i class="fas fa-upload"></i>
                      Seleccionar imagen
                      <input id="file" type="file" accept=".png, .jpg, .jpeg" style="visibility: hidden;"
                        (change)="onFileSelectedShowCrop($event)">
                    </label>
                  </p>

                </div>
                <div class="col-lg-9">
                  <div class="loading content_loading" id="box-loading-gallery">
                    <div class="spinner" role="status">
                      <div class="inner one"></div>
                      <div class="inner two"></div>
                      <div class="inner three"></div>
                    </div>
                    <p id="text">Cargando...</p>
                  </div>
                  <ng-container *ngIf="isCropping">
                    <div class="loading content_loading" id="box-loading-gallery">
                      <div class="spinner" role="status">
                        <div class="inner one"></div>
                        <div class="inner two"></div>
                        <div class="inner three"></div>
                      </div>
                      <p id="text">Cambiando imagen...</p>
                    </div>
                  </ng-container>
                  <div class="row">
                    <input #fileInput type="file" (change)="fileChangeEvent($event)" accept="image/*" multiple>
                    <span class="badge">/ N° máximo de <span class="bold">{{numberMaxImg}}</span> imágenes</span>
                    <div class="col-12">
                      <div *ngIf="imageChangedEvent" style="width: 50%;">
                        <!-- <image-cropper class="custom-cropper" [imageChangedEvent]="imageChangedEvent"
                          [maintainAspectRatio]="false" [resizeToWidth]="1000" format="jpeg"
                          (imageCropped)="imageCropped($any($event))">
                        </image-cropper> -->
                        <image-cropper class="custom-cropper" [imageChangedEvent]="imageChangedEvent"
                          [maintainAspectRatio]="true" [aspectRatio]="4 / 3" [resizeToWidth]="1000" format="jpeg"
                          (imageCropped)="imageCropped($any($event))">
                        </image-cropper>
                        <button type="button" class="btn btn-outline-secondary mt-2 me-2 m-r-5"
                          [disabled]="currentIndex === 0" (click)="goToPrevious()">← Anterior</button>
                        <button type="button" class="btn btn-warning mt-2 m-r-5" (click)="skipCurrent()">Omitir</button>
                        <button type="button" class="btn btn-info mt-2" (click)="cropAndNext()">Recortar y
                          siguiente</button>
                      </div>
                    </div>
                    <div class="col-12 p-0 m-t-15 m-b-30">
                      <div *ngIf="croppedImages.length > 0">
                        <h5 class="f-s-13 m-b-5">Imágenes preseleccionadas: <span
                            class="badge badge-warning text-dark bold f-s-12">
                            <i class="fas fa-info-circle m-l-5"></i>
                            No olvider guardar para aplicar cambios
                          </span></h5>
                        <div class="d-flex flex-wrap">
                          <div class="position-relative" *ngFor="let img of croppedImages; let i = index">
                            <img [src]="img" class="m-2" style="max-width: 200px; height: 140px; border: 1px solid #ccc;">
                            <button type="button" class="btn btn-danger btn-sm position-absolute top-0 end-0"
                              style="z-index: 1; right: 5px;" (click)="removeImage(i)">
                              ✕
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <ng-container *ngIf="photosOld.length > 0">
                      <div class="col-12">
                        <p class="bold text-primary f-s-15">IMÁGENES SUBIDAS:</p>
                      </div>
                    </ng-container>
                    <div class="col-12">
                      <ng-container *ngIf="photosOld.length > 0">
                        <div class="row" #sortableContainer>
                          <div class="col-lg-3 m-b-35 p-l-10 p-r-10"
                            *ngFor="let file of photosOld; let index_ = index; trackBy: trackById"
                            [attr.data-id]="file.id" style="cursor: move;">
                            <img style="width: 100%; height: 80%; border-radius: 4px;"
                              src="tenants/{{ file.url_image }}" alt="Image Preview" />
                            <div class="row m-t-5">
                              <div class="col-lg-12">
                                <div class="input-group">
                                  <div class="input-group-prepend">
                                    <div class="input-group-text">
                                      <i class="fas fa-info-circle" data-toggle="tooltip" data-placement="right"
                                        data-original-title="Descripción de la imágen"></i>
                                    </div>
                                  </div>
                                  <input type="text" class="form-control sale__input" placeholder="Descripción"
                                    (keyup)="changeTagImageOld($event.target, index_)" [value]="file.tag" />
                                  <div class="input-group-append">
                                    <i class="far fa-trash-alt pointer f-s-17 text-danger m-t-5 m-l-5"
                                      (click)="removeImageOld(index_)"></i>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </ng-container>
                    </div>
                    <!-- <ng-container *ngIf="photosOld.length > 0">
                      <div class="col-lg-3 m-b-35 p-l-10 p-r-10" *ngFor="let file of photosOld; let index_ = index">
                        <img style="width: 100%; height: 80%" src="tenants/{{file.url_image}}" alt="Image Preview">
                        <div class="row m-t-5">
                          <div class="col-lg-12">
                            <div class="input-group">
                              <div class="input-group-prepend">
                                <div class="input-group-text"><i class="fas fa-info-circle" data-toggle="tooltip"
                                    data-placement="right" data-original-title="Descripción de la imágen"></i>
                                </div>
                              </div>
                              <input type="text" class="form-control sale__input" placeholder="Descripción"
                                (keyup)="changeTagImageOld($event.target, index_)" value="{{file.tag}}">
                            </div>
                          </div>
                          <div class="col-lg-8">
                            <div class="input-group">
                              <div class="input-group-prepend">
                                <div class="input-group-text"><i class="fas fa-info-circle" data-toggle="tooltip"
                                    data-placement="right"
                                    data-original-title="Posición en el carousel de la galería"></i>
                                </div>
                              </div>
                              <input type="text" class="form-control sale__input" numeric placeholder="Pos"
                                (keyup)="changePositionImageOld($event.target, index_)" onclick="click_input(this)"
                                value="{{file.position}}">
                              <i class="far fa-trash-alt pointer f-s-15 text-danger m-t-5 m-l-5"
                                (click)="removeImageOld(index_)"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-container> -->

                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="form-group col-lg-12 form__footerBtn m-t-100">
            <div class="text-right">
              <a class="btn btn-secondary" (click)="cancel()">Cancelar</a>
              <button type="submit" class="btn btn-primary waves-effect waves-light">
                <i class="far fa-save m-r-5"></i>
                Guardar
                Cambios
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  <!-- sample modal portada -->
  <div id="modalCroppedCover" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title mt-0">Recortar imagen</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div *ngIf="imageCoverChangedEvent" style="width: 70%;">
            <image-cropper [imageChangedEvent]="imageCoverChangedEvent" [maintainAspectRatio]="true"
              [aspectRatio]="4 / 3" [resizeToWidth]="1000" format="jpeg" (imageCropped)="imageCroppedCover($event)">
            </image-cropper>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
          <button type="button" class="btn btn-primary" (click)="confirmCrop()">Seleccionar imagen</button>
        </div>
      </div>
    </div>
  </div>
</div>
